var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "plans-list" },
    _vm._l(_vm.plans.list, function(plan) {
      return _c(
        "li",
        {
          class: [
            "plan-" + plan.id,
            { available: _vm.available(plan), view: _vm.view }
          ],
          on: {
            click: function($event) {
              _vm.choose(plan)
            }
          }
        },
        [
          _c("h4", [
            _vm._v("\n      " + _vm._s(_vm._f("text")(plan.name)) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "price" },
            [
              _c("Cell", {
                attrs: {
                  item: plan,
                  field: _vm.priceField,
                  name: _vm.priceFieldName
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm._f("text")(plan.description)))]),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.viewing = !_vm.viewing && plan.id
                }
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm._f("trans")("buttons.show")) + "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.clickable
            ? _c(
                "a",
                {
                  attrs: {
                    disabled: _vm.current && _vm.current.id === plan.id,
                    title: _vm.tooltip(plan)
                  },
                  on: {
                    click: function($event) {
                      _vm.choose(plan)
                    }
                  }
                },
                [
                  _vm.current && _vm.current.id === plan.id
                    ? _c("span", [_vm._v(_vm._s(_vm.tooltip(plan)))])
                    : plan.id === _vm.value
                      ? _c("Icon", { attrs: { name: "tick" } })
                      : _c("span", [_vm._v(" ")])
                ],
                1
              )
            : _c("label", [
                _vm.current && _vm.current.id === plan.id
                  ? _c("span", [_vm._v(_vm._s(_vm.tooltip(plan)))])
                  : _c("span", [_vm._v(" ")])
              ]),
          _vm._v(" "),
          _vm.viewing === plan.id
            ? _c(
                "Wizard",
                { staticClass: "sm", attrs: { logo: false } },
                [
                  _c("PlanOverview", {
                    staticClass: "details",
                    attrs: { plan: plan }
                  }),
                  _vm._v(" "),
                  _c("a", {
                    directives: [{ name: "close", rawName: "v-close" }],
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.viewing = null
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41c3a6a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c3a6a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/billings/components/BillingPlans.vue
// module id = null
// module chunks = 